// Global Types
import { AppState } from 'services/types';
import { WorkTypeId } from 'services/workTypes/types';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
import { selectHarvestSchemaWorkTypeIds } from 'services/schemas/selectors';

// Local Types
import { OwnProps } from '.';

const selectWorkTypeId = (_state: AppState, props: OwnProps): WorkTypeId =>
    props.workTypeId;

const selectIsHarvestSchemaWorkType = createDeepEqualSelector(
    [selectHarvestSchemaWorkTypeIds, selectWorkTypeId],
    (harvestSchemaWorkTypeIds, workTypeId) => {
        if (harvestSchemaWorkTypeIds && harvestSchemaWorkTypeIds.length) {
            return harvestSchemaWorkTypeIds.includes(workTypeId);
        }

        return false;
    }
);

const makeSelectIsHarvestSchemaWorkType = (): typeof selectIsHarvestSchemaWorkType =>
    selectIsHarvestSchemaWorkType;

export { makeSelectIsHarvestSchemaWorkType };
